// extracted by mini-css-extract-plugin
module.exports = {"timeButton":"jWi5XX3kNkiR55KCaTZCG","messageCategoryButton":"_3bO6LtvBfHc5FExR9qpja"};